import { TemporalCondition } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { DateTypeProps } from '@new/__global/components/DatePickerCustomFilter/DatePickerCustomFilter.types'

export const dateTypeByTemporalCondition = {
  [TemporalCondition.equals]: DateTypeProps.exactDate,
  [TemporalCondition.before]: DateTypeProps.before,
  [TemporalCondition.after]: DateTypeProps.after,
}
